import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"
import { cn } from "../../lib/utils"

const Progress = React.forwardRef(({ className, value, max = 100, ...props }, ref) => {
  const clampedValue = value === null || value === undefined ? null : Math.max(0, Math.min(max, value));
  const isIndeterminate = clampedValue === null;
  
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
        className
      )}
      value={clampedValue}
      max={max}
      data-state={isIndeterminate ? "indeterminate" : "determinate"}
      aria-valuenow={clampedValue}
      aria-valuemax={max}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className="h-full w-full flex-1 bg-primary transition-all"
        style={isIndeterminate ? {} : { transform: `translateX(-${100 - (clampedValue / max * 100)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }